import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';
import { url } from '@/helpers/UrlHelpers';

export default class getCouponsHistory {
    apiService

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
        this.apiService.enableAuth();
    }

    async handle() {
        const apiUrl = url(ApiEndpoints['couponsHistory']);
        let request = await this.apiService
            .get(apiUrl)
            .catch(() => false);

        return request ? request.data.data : [];
    }
}
